import { pitch } from "./constants";
import { default_options, MOVEMENT } from "./sequencer";
var pitch_note_map = function (noteSet) {
    switch (noteSet) {
        case "P/S": return { up: function (pitch) { return (pitch + 7) % 12; }, down: function (pitch) { return pitch; } };
        case "M/S": return { up: function (pitch) { return (pitch + 6) % 12; }, down: function (pitch) { return pitch; } };
        case "Ś/S": return { up: function (pitch) { return pitch; }, down: function (pitch) { return pitch; } };
        case "P/N": return { up: function (pitch) { return (pitch + 7) % 12; }, down: function (pitch) { return (pitch + 11) % 12; } };
    }
};
export var get_notes = function (sequence, play, options) {
    if (options === void 0) { options = default_options; }
    var base_pitch_idx = pitch.findIndex(function (el) { return el.id === options.pitch; });
    var map_fn = pitch_note_map(options.noteSets);
    var pitch_map = {
        "down": pitch[map_fn.down(base_pitch_idx)].id,
        "up": pitch[map_fn.up(base_pitch_idx)].id
    };
    return sequence.map(function (letter, index) {
        if (play[index]) {
            switch (letter) {
                case MOVEMENT.UP: return pitch_map.up + "4";
                case MOVEMENT.DOWN: return pitch_map.down + "3";
            }
        }
        else {
            return "K";
        }
    });
};
